<script lang="ts">
// @ts-nocheck
import ButtonDefaultComponent from "@/components/Forms/Button/ButtonDefaultComponent.vue";
import FormInputDefaultComponent from "@/components/Forms/Input/FormInputDefaultComponent.vue";
import { defineComponent, reactive, watchEffect } from "vue";

import type { $string } from "@/configs/types/Shared/typeShare";
import loadImage from "blueimp-load-image";
import { Capacitor } from "@capacitor/core";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { Geolocation } from "@capacitor/geolocation";
import { useAuthStore } from "../Authentication/stores/useAuthStore";
import { useSharedStore } from "@/stores/PoliceCommandCenter/useSharedStore";
import { useHistorySearchStore } from "./stores/useHistorySearchStore";
import { useChatFormStore } from "./stores/useChatFormStore";
import { useIncidentFormStore } from "../IncidentManagement/stores/useIncidentFormStore";
import { TransitionRoot, Dialog, DialogPanel } from "@headlessui/vue";
import { useMasterDataStore } from "@/stores/Shared/useMasterDataStore";
import BadgeDefaultComponent from "@/components/Forms/Badge/BadgeDefaultComponent.vue";
import LoadingFormComponent from "@/components/Loadings/LoadingFormComponent.vue";
import { isCommandCenterApp, setLocalStorage } from "@/configs/helpers/MainHelper";
import { useInfiniteScroll } from "@vueuse/core";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import _ from "lodash";

export default defineComponent({
  name: "ChatView",
  components: {
    TransitionRoot,
    Dialog,
    DialogPanel,
    LoadingFormComponent,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
  },
  data() {
    return {
      componentName: this.$options.name,
      policeProfileImage: new URL(`@/assets/images/police-profile.svg`, import.meta.url).href,
      isMobile: false,
      selectedItem: null,
      isVisible: false,
      caller: "",
      incidentID: null as any,
    };
  },
  computed: {
    defaultFormComponents() {
      return {
        form: {
          input: {
            message: {
              component: FormInputDefaultComponent,
              props: {
                isSpecial: true,
                isVisible: true,
                isError: (this.chatFormStore.error[`message`] || "").length > 0,
                isIcon: false,
                isDisable: this.chatFormStore.loading,
                isRequired: this.chatFormStore.isRequired.message.is,
                textError: "",
                title: this.$t(this.chatFormStore.isRequired.message.label),
                name: `message`,
                placeholder: this.$t(this.chatFormStore.isRequired.message.placeholder),
                value: this.chatFormStore.result.message,
              } as typeof FormInputDefaultComponent.props,
              onUpdateValue: (value: $string) => {
                this.chatFormStore.result.message = value;
                this.chatFormStore.message = value;
              },
            },
            name: {
              component: FormInputDefaultComponent,
              props: {
                isSpecial: true,
                isVisible: true,
                isError: (this.chatFormStore.locationError[this.chatFormStore.isRequiredLocation.name.name] || "").length > 0,
                isIcon: false,
                isDisable: false,
                isRequired: this.chatFormStore.isRequiredLocation.name.is,
                textError: this.$t(this.chatFormStore.isRequiredLocation.name.placeholder),
                title: this.$t(this.chatFormStore.isRequiredLocation.name.label),
                placeholder: this.$t(this.chatFormStore.isRequiredLocation.name.placeholder),
                value: this.chatFormStore?.resultLocation?.name,
                name: this.chatFormStore.isRequiredLocation.name.name,
              } as typeof FormInputDefaultComponent.props,
              onUpdateValue: (value: $string) => {
                this.chatFormStore.resultLocation.name = value;
              },
            },
          },
          button: {
            btnManage: {
              component: ButtonDefaultComponent,
              props: {
                isSpecial: false,
                isVisible: true,
                isIcon: true,
                componentIcon: this.$outlineIcons.PencilSquareIcon,
                classIcon: "ttp-icon-inside-box-03 inline-block",
                isLoading: this.loading(),
                isDisable: this.loading(),
                title: this.$t("btn.btn_manage"),
                classEnumName: this.$enums.ENUM_COLOR.DEFAULT_1,
                size: this.$enums.ENUM_SIZE.SMALL,
              } as typeof ButtonDefaultComponent.props,
            },
          },
          badge: {
            status: {
              component: BadgeDefaultComponent,
              props: {
                htmlIcon: "",
                isSpecial: false,
                isVisible: true,
                isIcon: true,
                isDisable: false,
                size: this.$enums.ENUM_SIZE.NORMAL,
              } as typeof BadgeDefaultComponent.props,
            },
          },
        },
      };
    },
  },
  methods: {
    async generateAfterSubmit() {
      setTimeout(async () => {
        await this.$configLightbox();
      }, 10);
      this.scrollBottom(100);
    },
    async changeFile(e: any) {
      await this.chatFormStore.handleFileChange(e);
      await this.generateAfterSubmit();
    },
    async checkVoiceCall() {
      this.sharedStore.permissionResults = [];
      this.sharedStore.isLoadingPermission = true;
      Promise.all([
        (async () => {
          return await this.getMicrophonePermission();
        })(),
        (async () => {
          return await this.getLocationPermission();
        })(),
        (async () => {
          return await this.getPhotoLibraryPermission();
        })(),
      ]).then(async ([resultA, resultB, resultC]) => {
        if (resultA === true && resultB === true && resultC === true) {
          this.sharedStore.isShowPermission = false;
        } else {
          // POPUP
          this.sharedStore.isShowPermission = true;
        }
        this.sharedStore.isLoadingPermission = false;
      });
    },
    async openAppSetting() {
      if (Capacitor.isNativePlatform()) {
        await (this.$PermissionsPlugin as any).openAppSettings();
      }
    },
    async geolocationToggle() {
      if (Capacitor.isNativePlatform()) {
        this.openAppSetting();
      } else {
        try {
          await navigator.geolocation.getCurrentPosition(
            async () => {
              await setLocalStorage(this.sharedStore.is_track_location, "granted");
            },
            async () => {
              await setLocalStorage(this.sharedStore.is_track_location, "denied");
            }
          );
        } catch (error) {
          await setLocalStorage(this.sharedStore.is_track_location, "denied");
        }
      }
    },
    async microphoneToggle() {
      if (Capacitor.isNativePlatform()) {
        this.openAppSetting();
      } else {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          stream.getTracks().forEach((track) => track.stop());
          await setLocalStorage(this.sharedStore.is_microphone, "granted");
        } catch (error) {
          this.openAppSetting();
          await setLocalStorage(this.sharedStore.is_microphone, "denied");
        }
      }
    },
    async socketVoiceOnReceived() {
      await this.$voiceSocket.on("message.received", (payload: any) => {});
    },
    async connectChat() {
      if (this.$chatSocket) {
        await this.chatFormStore.setIncident(String(this.$route.params.id ? this.$route.params.id : this.incidentID), this.$enums.ENUM_CHAT_SENDER.USER, this.authStore?.user?.id);
        await this.$chatSocket.connect();
      }
    },
    async connectVoice() {
      if (this.$voiceSocket) {
        this.$voiceSocket.auth = {
          incidentID: this.$route.params.id ? this.$route.params.id : this.incidentID,
          userType: isCommandCenterApp ? this.$enums.ENUM_CHAT_SENDER.USER : this.$enums.ENUM_CHAT_SENDER.TOURIST,
          userID: this.authStore?.user?.id,
        };
        await this.$voiceSocket.connect();
      }
    },
    async socketChatOnReceived() {
      await this.$chatSocket.on("message.received", async (payload: any) => {
        if (payload?.message?.type !== this.$enums.ENUM_CHAT_TYPE.MAKE_A_CALL) {
          this.chatFormStore.roomId = payload?.message?.content?.roomId;
          this.chatFormStore.startAt = payload?.message?.content?.startAt;
          this.chatFormStore.endAt = payload?.message?.content?.endAt;
          this.chatFormStore.replyID = payload?.refID;
          await setLocalStorage(`roomId`, payload?.message?.content?.roomId);

          // Get Image
          if (payload?.message?.type == this.$enums.ENUM_CHAT_TYPE.IMAGES) {
            if (payload?.message?.content?.length) {
              payload.message.content = await Promise.all(await this.chatFormStore.fetchFile.Get(payload?.message?.content));
              await this.generateAfterSubmit();
            }
          }

          await this.chatFormStore.messages.push(payload);
          this.scrollBottom(100);
        }
      });
    },
    closeCamera() {
      if (this.chatFormStore.stream) {
        this.chatFormStore.stream.getTracks().forEach((track: any) => track.stop());
        this.chatFormStore.stream = null;
      }
      this.chatFormStore.isCamera = !this.chatFormStore.isCamera;
    },
    async startCamera() {
      try {
        if (Capacitor.isNativePlatform()) {
          this.chatFormStore.photo = null;

          const capturedPhoto = await Camera.getPhoto({
            resultType: CameraResultType.Uri,
            source: CameraSource.Camera,
            quality: 100,
          });

          const response = await fetch(capturedPhoto.webPath!);
          const blob = await response.blob();

          const currentDate = new Date();
          const dateString = currentDate.toISOString().replace(/[:.]/g, "-");
          const fileName = `custom_${dateString}.jpg`;

          const file = new File([blob], fileName, { type: "image/jpeg" });

          const results = await this.chatFormStore.fetchFile.Upload([file]);
          this.chatFormStore.imageIds = await results.map((item: any) => item.id);
          this.chatFormStore.imageUrls = await this.chatFormStore.fetchFile.Get(this.chatFormStore.imageIds);

          this.chatFormStore.update(this.$enums.ENUM_CHAT_TYPE.IMAGES, this.chatFormStore.imageIds);
          this.chatFormStore.messages[this.$findIndexById(this.chatFormStore.messages, this.chatFormStore.id)].child = "Hide";
          await this.generateAfterSubmit();
        } else {
          this.chatFormStore.photo = null;
          this.chatFormStore.isCamera = !this.chatFormStore.isCamera;
          this.chatFormStore.stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: {
              facingMode: "environment",
            },
          });

          (this.$refs as any).video.srcObject = this.chatFormStore.stream;

          (this.$refs as any).video.onloadedmetadata = () => {
            this.chatFormStore.ready = true;
          };

          (this.$refs as any).video.onended = () => {
            this.chatFormStore.ready = false;
            this.chatFormStore.stream = null;
          };
        }
      } catch (error) {
        console.error("Error accessing camera:", error);
      }
    },
    capturePhoto() {
      let video = (this.$refs as any).video;

      let videoCanvas = document.createElement("canvas");
      videoCanvas.height = video.videoHeight;
      videoCanvas.width = video.videoWidth;
      let videoContext = videoCanvas.getContext("2d") as any;

      videoContext.drawImage(video, 0, 0);

      this.chatFormStore.photo = loadImage.scale(videoCanvas, {});

      this.uploadPhoto();

      this.chatFormStore.stream.getTracks().forEach((track: any) => track.stop());
      this.chatFormStore.stream = null;
    },
    uploadPhoto() {
      this.chatFormStore.photo.toBlob(async (blob: any) => {
        const currentDate = new Date();
        const dateString = currentDate.toISOString().replace(/[:.]/g, "-");
        const fileName = `custom_${dateString}.jpg`;

        const file = new File([blob], fileName, { type: "image/jpeg" });

        const results = await this.chatFormStore.fetchFile.Upload([file]);
        this.chatFormStore.imageIds = await results.map((item: any) => item.id);
        this.chatFormStore.imageUrls = await this.chatFormStore.fetchFile.Get(this.chatFormStore.imageIds);

        this.chatFormStore.update(this.$enums.ENUM_CHAT_TYPE.IMAGES, this.chatFormStore.imageIds);
        this.chatFormStore.messages[this.$findIndexById(this.chatFormStore.messages, this.chatFormStore.id)].child = "Hide";
        await this.generateAfterSubmit();
      }, "image/jpeg");
    },
    toggleSelect() {
      this.isMobile = !this.isMobile;
    },
    async setting() {
      await this.fetch();
      await this.fetchScroll();

      if (this.$route.params.id ? this.$route.params.id : this.incidentID) await this.getMessageRoom();
      await this.generateAfterSubmit();

      await setLocalStorage("roomId", "");
    },
    async fetch() {
      if (this.$route.params.id ? this.$route.params.id : this.incidentID) {
        await Promise.all([
          (async () => {
            // Get Incident

            this.incidentFormStore.result = await this.incidentFormStore.fetchIncident.Get(String(this.$route.params.id ? this.$route.params.id : this.incidentID));

            // Get Image
            if (this?.incidentFormStore?.result?.images?.length) {
              this.incidentFormStore.result.images = await Promise.all(await this.incidentFormStore.fetchFile.Get(this?.incidentFormStore?.result?.images));
            }
            await this.generateAfterSubmit();
          })(),
        ]);
      }
    },
    async fetchScroll() {
      if (!this.historySearchStore.loadingScroll) {
        this.historySearchStore.currentPage = this.historySearchStore.currentPage + 1;

        let results = (await this.historySearchStore.onUpdateUnlimitedScrollCurrentPage(this.historySearchStore.currentPage)) as any;

        if (!this.historySearchStore.filterTableResults) {
          this.historySearchStore.tableResults = results;
          this.historySearchStore.filterTableResults = _.cloneDeep(results);
          this.historySearchStore.totalPage = results?.totalPages;
        } else {
          this.historySearchStore.tableResults.items.push(...results?.items);
          this.historySearchStore.tableResults.totalPage = this.historySearchStore.tableResults.totalPages;
          results = this.historySearchStore.tableResults;
        }
        this.historySearchStore.filterTableResults.items = results.items;
        this.historySearchStore.actionStatus = this.$enums.ENUM_MUTATION_STATUS.SUCCESS;
        this.historySearchStore.loadingScroll = false;

        await this.scrollBottom(100);
      }
    },
    async getMessageRoom() {
      this.chatFormStore.messages = await this.chatFormStore.fetchIncident.GetListIncidentChat(String(this.$route.params.id ? this.$route.params.id : this.incidentID), this.masterDataStore.lang());

      // Last Auto Reply
      if (this.chatFormStore.messages.length) {
        // Get Image
        if (this.$findIndexesOfImages(this.chatFormStore.messages).length) {
          await Promise.all(
            this.$findIndexesOfImages(this.chatFormStore.messages).map(async (index) => {
              this.chatFormStore.messages[index].message.content = await this.chatFormStore.fetchFile.Get(this.chatFormStore.messages[index]?.message?.content);
            })
          );
          await this.generateAfterSubmit();
        }

        // Get Image From Google Map
        if (this.$findIndexesOfLocations(this.chatFormStore.messages).length) {
          await Promise.all(
            this.$findIndexesOfLocations(this.chatFormStore.messages).map(async (index) => {
              const data = this.chatFormStore.messages[index]?.message?.content;
              const result = Object.values({
                latitude: data?.latitude,
                longitude: data?.longitude,
              }).join(",");

              this.chatFormStore.messages[index].message.content = {
                ...this.chatFormStore.messages[index]?.message?.content,
                url: await this.chatFormStore.getStaticMap(result),
              };
            })
          );
        }

        // Last Auto Reply
        const lastIndex = await this.chatFormStore.messages.map((obj: any) => obj.sender).lastIndexOf(this.$enums.ENUM_CHAT_SENDER.SYSTEM);
        this.chatFormStore.replyID = this.chatFormStore.messages[lastIndex].id;
      }

      await this.scrollBottom(100);
    },
    loading() {
      return false;
    },
    async reset() {
      await this.chatFormStore.$reset();
      await this.incidentFormStore.$reset();
      await setLocalStorage("roomId", "");
    },
    scrollBottom(number: number) {
      setTimeout(() => {
        if (this.$refs.scrollContainer) {
          const container = this.$refs.scrollContainer as HTMLElement;

          container.scrollTop = container.scrollHeight;
        }
        this.chatFormStore.loading = false;
      }, number);
    },
    settingMap() {
      this.chatFormStore.resultLocation.latitude = 13.736717;
      this.chatFormStore.resultLocation.longitude = 100.523186;
      this.initializeMap();
      this.scrollBottom(100);
    },
    async initializeMap() {
      const google = await this.$asyncGoogleMapsLoader();
      const { Map } = (await google.maps.importLibrary("maps")) as any;
      const { AdvancedMarkerElement } = (await google.maps.importLibrary("marker")) as any;

      var thailandCoordinates = { lat: 13.736717, lng: 100.523186 };

      const map = new Map(document.getElementById("map_chat") as HTMLElement, {
        center: thailandCoordinates,
        zoom: 14,
        mapId: "4504f8b37365c3d0",
        mapTypeId: "roadmap",
      });

      const draggableMarker = new AdvancedMarkerElement({
        map,
        position: thailandCoordinates,
        gmpDraggable: true,
        title: "This marker is draggable.",
      });

      if (navigator.geolocation) {
        const position = await Geolocation.getCurrentPosition();
        var selfCoordinates = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.chatFormStore.resultLocation.latitude = position.coords.latitude;
        this.chatFormStore.resultLocation.longitude = position.coords.longitude;

        map.setCenter(selfCoordinates);
        draggableMarker.position = selfCoordinates;

        const geocoder = new google.maps.Geocoder();
        const result = await geocoder.geocode(
          { location: selfCoordinates },
          function (results: any, status: any) {
            if (status === "OK") {
              if (results[0]) {
                const address = results[0].formatted_address;

                (document.getElementById("name") as HTMLInputElement).value = address;
              }
            } else {
              console.error("Geocoder failed due to: " + status);
            }
          }.bind(this)
        );
        this.chatFormStore.resultLocation.name = result.results[0].formatted_address;
      }

      draggableMarker.addListener("dragend", async (e: any) => {
        const position = draggableMarker.position as any;
        this.chatFormStore.resultLocation.latitude = position.lat;
        this.chatFormStore.resultLocation.longitude = position.lng;

        const newPosition = {
          lat: e.latLng.lat(),
          lng: e.latLng.lng(),
        } as any;

        const geocoder = new google.maps.Geocoder();
        const result = await geocoder.geocode(
          { location: newPosition },
          function (results: any, status: any) {
            if (status === "OK") {
              if (results[0]) {
                const address = results[0].formatted_address;

                (document.getElementById("name") as HTMLInputElement).value = address;
              }
            } else {
              console.error("Geocoder failed due to: " + status);
            }
          }.bind(this)
        );
        this.chatFormStore.resultLocation.name = result.results[0].formatted_address;
      });

      const input = document.getElementById("name") as HTMLInputElement;
      const searchBox = new google.maps.places.SearchBox(input);
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

      map.addListener("bounds_changed", () => {
        searchBox.setBounds(map.getBounds() as any);
      });

      let markers: any[] = [];
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length == 0) return;
        markers.forEach((marker) => {
          marker.setMap(null);
        });
        markers = [];
        const bounds = new google.maps.LatLngBounds();

        places.forEach((place: any) => {
          if (!place.geometry || !place.geometry.location) return;

          draggableMarker.position = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };

          this.chatFormStore.resultLocation.latitude = place.geometry.location.lat();
          this.chatFormStore.resultLocation.longitude = place.geometry.location.lng();
          this.chatFormStore.resultLocation.name = `${place.name}, ${place.formatted_address}`;

          if (place.geometry.viewport) {
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        map.fitBounds(bounds);
      });
    },
    async scrollFetch() {
      useInfiniteScroll(
        this.el,
        async () => {
          if (this.historySearchStore.totalPage > this.historySearchStore.currentPage) await this.fetchScroll();
        },
        { distance: 10 }
      );
    },
    async connect() {
      await this.connectChat();
      await this.socketChatOnReceived();
      await this.connectVoice();
      await this.socketVoiceOnReceived();
    },
    async disconnect() {
      await this.$chatSocket.off("message.received");
      await this.$chatSocket.disconnect();

      this.$voiceSocket.off("ready");
      await this.$voiceSocket.off("candidate");
      await this.$voiceSocket.off("offer");
      await this.$voiceSocket.off("answer");
      await this.$voiceSocket.off("message.received");
      await this.$voiceSocket.disconnect();
    },
    async getPhotoLibraryPermission() {
      if (Capacitor.isNativePlatform()) {
        try {
          await this.$PermissionsPlugin.requestPhoto();

          const result = await this.$PermissionsPlugin
            .checkPermissionPhoto()
            .then(async (_result: any) => {
              await setLocalStorage(this.sharedStore.is_photo, _result.value);
              if (_result.value == "granted") {
                this.$popUnique(this.sharedStore.permissionResults, "Photo");
              } else {
                this.$pushUnique(this.sharedStore.permissionResults, "Photo");
              }
              return _result.value == "granted" ? true : false;
            })
            .catch(async (_error: any) => {
              await setLocalStorage(this.sharedStore.is_photo, "denied");
              this.$pushUnique(this.sharedStore.permissionResults, "Photo");
              return false;
            });

          return result;
        } catch (_error) {
          await setLocalStorage(this.sharedStore.is_photo, "denied");
          this.$pushUnique(this.sharedStore.permissionResults, "Photo");
          return false;
        }
      } else {
        await setLocalStorage(this.sharedStore.is_photo, "granted");
        this.$popUnique(this.sharedStore.permissionResults, "Photo");
        return true;
      }
    },
    async getCameraPermission() {
      if (Capacitor.isNativePlatform()) {
        try {
          await this.$PermissionsPlugin.requestCamera();

          const result = await this.$PermissionsPlugin
            .checkPermissionCamera()
            .then(async (_result: any) => {
              await setLocalStorage(this.sharedStore.is_camera, _result.value);
              if (_result.value == "granted") {
                this.$popUnique(this.sharedStore.permissionResults, "Camera");
              } else {
                this.$pushUnique(this.sharedStore.permissionResults, "Camera");
              }
              return _result.value == "granted" ? true : false;
            })
            .catch(async (_error: any) => {
              await setLocalStorage(this.sharedStore.is_camera, "denied");
              this.$pushUnique(this.sharedStore.permissionResults, "Camera");
              return false;
            });
          return result;
        } catch (_error) {
          await setLocalStorage(this.sharedStore.is_camera, "denied");
          this.$pushUnique(this.sharedStore.permissionResults, "Camera");
          return false;
        }
      } else {
        try {
          const permission = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
          if (permission) {
            permission.getTracks().forEach((track) => track.stop());
          }
          await setLocalStorage(this.sharedStore.is_camera, "granted");
          this.$popUnique(this.sharedStore.permissionResults, "Camera");
          return true;
        } catch (_error) {
          await setLocalStorage(this.sharedStore.is_camera, "denied");
          this.$pushUnique(this.sharedStore.permissionResults, "Camera");
          return false;
        }
      }
    },
    async getMicrophonePermission() {
      if (Capacitor.isNativePlatform()) {
        try {
          await this.$PermissionsPlugin.requestMicrophone();

          const result = await this.$PermissionsPlugin
            .checkPermissionMicrophone()
            .then(async (_result: any) => {
              await setLocalStorage(this.sharedStore.is_microphone, _result.value);
              if (_result.value == "granted") {
                this.$popUnique(this.sharedStore.permissionResults, "Microphone");
              } else {
                this.$pushUnique(this.sharedStore.permissionResults, "Microphone");
              }
              return _result.value == "granted" ? true : false;
            })
            .catch(async (_error: any) => {
              await setLocalStorage(this.sharedStore.is_microphone, "denied");
              this.$pushUnique(this.sharedStore.permissionResults, "Microphone");
              return false;
            });
          return result;
        } catch (_error) {
          await setLocalStorage(this.sharedStore.is_microphone, "denied");
          this.$pushUnique(this.sharedStore.permissionResults, "Microphone");
          return false;
        }
      } else {
        try {
          const permission = await navigator.mediaDevices.getUserMedia({ audio: true });
          permission.getTracks().forEach((track) => track.stop());
          await setLocalStorage(this.sharedStore.is_microphone, "granted");
          this.$popUnique(this.sharedStore.permissionResults, "Microphone");
          return true;
        } catch (_error) {
          await setLocalStorage(this.sharedStore.is_microphone, "denied");
          this.$pushUnique(this.sharedStore.permissionResults, "Microphone");
          return false;
        }
      }
    },
    async getLocationPermission() {
      if (Capacitor.isNativePlatform()) {
        try {
          // const permission = await this.$PermissionsPlugin.requestLocation();
          await Geolocation.getCurrentPosition().then((permission: any) => {
            this.sharedStore.position = permission;
          });

          const result = await this.$PermissionsPlugin
            .checkPermissionLocation()
            .then(async (_result: any) => {
              await setLocalStorage(this.sharedStore.is_track_location, _result.value);
              if (_result.value == "granted") {
                this.$popUnique(this.sharedStore.permissionResults, "Location");
              } else {
                this.$pushUnique(this.sharedStore.permissionResults, "Location");
              }
              return _result.value == "granted" ? true : false;
            })
            .catch(async (_error: any) => {
              await setLocalStorage(this.sharedStore.is_track_location, "denied");
              this.$pushUnique(this.sharedStore.permissionResults, "Location");
              return false;
            });

          return result;
        } catch (_error) {
          await setLocalStorage(this.sharedStore.is_track_location, "denied");
          this.$pushUnique(this.sharedStore.permissionResults, "Location");
          return false;
        }
      } else {
        try {
          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
              async (permission) => {
                this.sharedStore.position = permission;

                await setLocalStorage(this.sharedStore.is_track_location, "granted");
                this.$popUnique(this.sharedStore.permissionResults, "Location");
                resolve(true);
              },
              async (_error) => {
                await setLocalStorage(this.sharedStore.is_track_location, "denied");
                this.$pushUnique(this.sharedStore.permissionResults, "Location");
                reject(false);
              }
            );
          });
          return position;
        } catch (_error) {
          await setLocalStorage(this.sharedStore.is_track_location, "denied");
          this.$pushUnique(this.sharedStore.permissionResults, "Location");
          return false;
        }
      }
    },
    async getNotificationsPermission() {
      if (Capacitor.isNativePlatform()) {
        try {
          const permission = await this.$PermissionsPlugin.requestNotification();

          const result = await this.$PermissionsPlugin
            .checkPermissionNotification()
            .then(async (_result: any) => {
              await setLocalStorage(this.sharedStore.is_push_notification, _result.value);
              if (_result.value == "granted") {
                this.$popUnique(this.sharedStore.permissionResults, "Notification");
              } else {
                this.$pushUnique(this.sharedStore.permissionResults, "Notification");
              }
              return _result.value == "granted" ? true : false;
            })
            .catch(async (_error: any) => {
              await setLocalStorage(this.sharedStore.is_push_notification, "denied");
              this.$pushUnique(this.sharedStore.permissionResults, "Notification");
              return false;
            });
          return result;
        } catch (_error) {
          await setLocalStorage(this.sharedStore.is_push_notification, "denied");
          this.$pushUnique(this.sharedStore.permissionResults, "Notification");
          return false;
        }
      } else {
        try {
          const permission = (await PushNotifications.requestPermissions()) as any;
          if (permission === "granted") {
            await setLocalStorage(this.sharedStore.is_push_notification, "granted");
            this.$popUnique(this.sharedStore.permissionResults, "Notification");
            return true;
          } else {
            await setLocalStorage(this.sharedStore.is_push_notification, "denied");
            this.$pushUnique(this.sharedStore.permissionResults, "Notification");
            return false;
          }
        } catch (_error) {
          await setLocalStorage(this.sharedStore.is_push_notification, "denied");
          this.$pushUnique(this.sharedStore.permissionResults, "Notification");
          return false;
        }
      }
    },
    cancelMessage(refID) {
      this.chatFormStore.cancel(refID)
    }
  },
  async mounted() {
    if (this.$route.params.id) this.incidentID = this.$route.params.id;

    await this.connect();

    await this.setting();
    await this.scrollFetch();

    watchEffect(async () => {
      if (this.incidentID) {
        await this.disconnect();
        const newUrl = `${this.$window.location.origin}/incident-management/chat/${this.incidentID}`;
        this.$route.params.id = this.incidentID;
        await this.connect();
        this.$window.history.pushState({ path: newUrl }, "", newUrl);
        this.chatFormStore.messages = null;
        this.chatFormStore.loading = true;
        await this.getMessageRoom();
        await this.fetch();
      }
    });
  },
  async unmounted() {
    await this.reset();
    await this.disconnect();
  },
  setup() {
    const authStore = useAuthStore();
    const chatFormStore = useChatFormStore();
    const sharedStore = useSharedStore();
    const historySearchStore = useHistorySearchStore();
    const incidentFormStore = useIncidentFormStore();
    const masterDataStore = useMasterDataStore();

    var state = reactive({
      el: null,
    });

    return { authStore, chatFormStore, sharedStore, historySearchStore, incidentFormStore, masterDataStore, el: state.el, state };
  },
});
</script>

<template>
  <div class="flex w-full h-[520px]">
    <div class="flex flex-col w-[420px] h-full">
      <div class="flex items-center justify-center border-b-[1px] p-4 h-[80px]">
        <span class="w-full ttp-text-md text-black font-bold">{{ $t("layout.menu.ChatView") }}</span>
        <span class="ttp-text-xxs text-black px-2.5 py-0.5 rounded bg-[#EFF4FB] float-right">{{ historySearchStore?.filterTableResults?.items?.length }}</span>
      </div>
      <div class="flex flex-col relative w-full gap-1 p-4">
        <input
          @input="
            async (e: any) => {
              historySearchStore.result.keyword = e.target.value;
              historySearchStore.tableResults = null;
              historySearchStore.filterTableResults = null;
              historySearchStore.currentPage = 0;
              await fetchScroll();
            }
          "
          id="message"
          type="text"
          name="message"
          placeholder="Search..."
          autocomplete="off"
          class="z-0 bg-gray-50 border border-gray-300 focus:border-ttp-primary text-gray-600 ttp-text-xs rounded-lg disabled:cursor-not-allowed disabled:bg-ttp-new block w-full p-2.5"
        />
        <component :is="$solidIcons.MagnifyingGlassIcon" class="inline-block ttp-icon-inside-box-03 absolute top-7 right-7" />
      </div>
      <div ref="el" class="flex flex-col w-full h-full gap-1 px-4 pb-4 overflow-auto">
        <div v-if="historySearchStore?.filterTableResults?.items?.length" v-for="(item, index) in historySearchStore?.filterTableResults?.items" :key="index" :class="[{ 'flex gap-2 w-full items-center justify-center rounded p-2 relative': true, ' bg-[#EFF4FB]': item?.incidentID == $route.params.id }]">
          <div class="flex relative">
            <div class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-300 dark:bg-gray-700 dark:text-gray-500">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" class="inline-block ttp-icon-inside-box-03"><path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clip-rule="evenodd"></path></svg>
            </div>
            <div v-if="false" class="inline-flex h-3 w-3 items-center justify-center rounded-full bg-[#10B981] -bg-[#DC2626] border-[2px] border-[#fff] text-gray-300 absolute right-0 bottom-0"></div>
          </div>
          <div
            @click="
              () => {
                incidentID = item?.incidentID;
              }
            "
            class="flex flex-col w-full cursor-pointer"
            v-if="item.sender == $enums.ENUM_CHAT_SENDER.TOURIST"
          >
            <div class="ttp-text-md text-black h-5 overflow-hidden">{{ item?.incident?.tourist?.name }}</div>

            <div class="ttp-text-xs text-black">{{ item?.incident?.incidentNumber }}</div>
            <div v-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.TEXT" class="ttp-text-xs text-[#637381] overflow-hidden">{{ $substr($convertString(item?.content ? item?.content : $hasNameAndValue(item?.message) ? (item?.message?.content.name ? item?.message?.content.name : $findPlaceholder(item)) : item?.message?.content ? item?.message?.content : $findPlaceholder(item)), 20) }}</div>
            <div v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.SELECTED" class="ttp-text-xs text-[#637381] overflow-hidden">{{ $substr($convertString(item?.content ? item?.content : $hasNameAndValue(item?.message) ? (item?.message?.content.name ? item?.message?.content.name : $findPlaceholder(item)) : item?.message?.content ? item?.message?.content : $findPlaceholder(item)), 20) }}</div>
            <div v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.IMAGES" class="ttp-text-xs text-[#637381] overflow-hidden">{{ "Attach File" }}</div>
            <div v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.LOCATION" class="ttp-text-xs text-[#637381] overflow-hidden">{{ $substr($convertString(item?.message?.content?.name), 20) }}</div>
          </div>
          <div
            @click="
              () => {
                incidentID = item?.incidentID;
              }
            "
            class="flex flex-col w-full cursor-pointer"
            v-else-if="$inArray(item.sender, [$enums.ENUM_CHAT_SENDER.SYSTEM, $enums.ENUM_CHAT_SENDER.USER])"
          >
            <div class="ttp-text-md text-black h-5 overflow-hidden">{{ item?.incident?.tourist?.name }}</div>

            <div class="ttp-text-xs text-black">{{ item?.incident?.incidentNumber }}</div>
            <div v-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.TEXT" class="ttp-text-xs text-[#637381] overflow-hidden">{{ $substr($convertString($removeHtmlTags($replaceString(item?.message?.content?.message, "%name%", $convertString(authStore?.user?.name)))), 20) }}</div>
            <div v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.SELECT" class="ttp-text-xs text-[#637381] overflow-hidden">{{ $substr($convertString(item?.message?.content?.message), 20) }}</div>
            <div v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.IMAGES" class="ttp-text-xs text-[#637381] overflow-hidden">{{ "Attach file" }}</div>
            <div v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.LOCATION" class="ttp-text-xs text-[#637381] overflow-hidden">{{ $substr($convertString(item?.message?.content?.message), 20) }}</div>
          </div>
        </div>
        <div v-if="historySearchStore.loadingScroll" class="flex flex-col gap-1 w-full rounded-lg p-3">
          <div class="m-auto text-center"><LoadingFormComponent class="text-black" /></div>
          <div class="ttp-text-xs text-black text-center">{{ $t("layout.loading") }}</div>
        </div>
        <div v-else-if="!historySearchStore?.filterTableResults?.items?.length" class="flex flex-col gap-1 w-full rounded-lg p-3">
          <div class="ttp-text-xs text-black text-center">ไม่พบข้อความใหม่</div>
        </div>
      </div>
    </div>
    <div v-if="$route.params.id ? $route.params.id : incidentID" class="flex flex-col w-full h-full border-l-[1px]">
      <div class="flex flex-col w-full border-b-[1px] p-4">
        <div class="flex gap-2 items-center justify-center w-full">
          <div class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-300 dark:bg-gray-700 dark:text-gray-500">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" class="inline-block ttp-icon-inside-box-03"><path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clip-rule="evenodd"></path></svg>
          </div>
          <div class="w-full">
            <LoadingFormComponent v-if="chatFormStore.loading" />
            <div v-else class="ttp-text-md text-black">{{ incidentFormStore?.result?.tourist?.name }} ({{ $t("form.case_number.label") }}: {{ incidentFormStore?.result?.incidentNumber }})</div>
            <div v-if="false" class="ttp-text-xs text-[#64748B]">{{ $t("page.ChatView.reply_message") }}</div>
            <div class="ttp-text-xs text-black">
              <div>ประเภทเรื่อง : {{ $convertString(masterDataStore.getIncidentCategoryByCodeAndLocale(incidentFormStore?.result?.information?.categoryCode, $enums.ENUM_FIELD_LOCALE.TH)) }}</div>
              <div>วันที่แจ้ง : {{  incidentFormStore?.result?.createdAt ? $dayjs(incidentFormStore.result.createdAt).format("DD/MM/YYYY HH:mm") : '-' }}</div>
              <div>วันที่ติดต่อล่าสุด​ : {{ chatFormStore?.messages?.length ? $dayjs(chatFormStore.messages[chatFormStore.messages.length - 1]?.createdAt).format("DD/MM/YYYY HH:mm") : '-' }}</div>
              <div>ผู้ดำเนินการ​ : {{ $convertString(incidentFormStore?.result?.assignee?.content[0].shortName) }}</div>
            </div>
          </div>
          <div>
            <button @click="checkVoiceCall" v-if="true && !$inArray(historySearchStore?.result?.status, [$enums.ENUM_INCIDENT_STATUS.COMPLETED, $enums.ENUM_INCIDENT_STATUS.IN_REVIEW, $enums.ENUM_INCIDENT_STATUS.REPORTED, $enums.ENUM_INCIDENT_STATUS.CLOSED, $enums.ENUM_INCIDENT_STATUS.REJECTED])">
              <component :is="$solidIcons.PhoneIcon" class="flex-none inline-block ttp-icon-inside-box-03 mx-1" />
            </button>
          </div>
          <div v-if="!$inArray(incidentFormStore?.result?.status, [$enums.ENUM_INCIDENT_STATUS.CLOSED, $enums.ENUM_INCIDENT_STATUS.REPORTED, $enums.ENUM_INCIDENT_STATUS.REJECTED])" class="w-full">
            <router-link
              v-if="true"
              :to="{
                name: 'IncidentManageView',
                params: { id: $route.params.id ? $route.params.id : incidentID },
              }"
              class="col-end-0 col-span-3 md:col-end-7 md:col-span-2 lg:col-end-7 lg:col-span-1"
            >
              <component classTagName="w-full" :is="defaultFormComponents.form.button.btnManage.component" v-bind="defaultFormComponents.form.button.btnManage.props" />
            </router-link>
          </div>
          <div>
            <button
              @click="
                () => {
                  isVisible = !isVisible;
                }
              "
              :disabled="incidentFormStore.loading"
              class="disabled:cursor-not-allowed"
            >
              <component :is="$outlineIcons.EllipsisVerticalIcon" class="inline-block ttp-icon-inside-box-03" />
            </button>
            <div v-if="isVisible" class="absolute right-1 origin-top-right z-10 mt-2 w-4/4 shadow-md rounded-lg dark:shadow-gray-900 focus:outline-none">
              <div class="bg-white ring-1 ring-black ring-opacity-5 rounded-lg divide-y divide-gray-100 dark:bg-gray-800 dark:divide-gray-700 dark:ring-gray-700">
                <div class="space-y-1">
                  <div>
                    <router-link
                      :to="{
                        name: 'IncidentNoticeView',
                        params: { id: $route.params.id ? $route.params.id : incidentID },
                      }"
                      class="group ttp-text-xs font-medium flex items-center justify-between space-x-2 px-2.5 py-2 rounded-lg border border-transparent"
                      :class="{
                        'text-teal-800 bg-teal-50 dark:text-white dark:bg-gray-700/75 dark:border-transparent': false,
                        'text-gray-700 hover:text-teal-800 hover:bg-teal-50 active:border-teal-100 dark:text-gray-200 dark:hover:text-white dark:hover:bg-gray-700/75 dark:active:border-gray-600': true,
                      }"
                    >
                      <component :is="$outlineIcons.EyeIcon" class="flex-none inline-block ttp-icon-inside-box-03 opacity-100 group-hover:opacity-100" />
                      <span class="grow text-gray-500 ttp-text-xs font-normal">{{ $t("btn.btn_view_notification") }}</span>
                    </router-link>
                  </div>
                </div>
                <div class="space-y-1">
                  <div>
                    <button @click="incidentFormStore.openHistoryModal" class="group ttp-text-xs font-medium flex items-center justify-between space-x-2 px-2.5 py-2 rounded-lg border border-transparent text-gray-700 hover:text-teal-800 hover:bg-teal-50 active:border-teal-100 dark:text-gray-200 dark:hover:text-white dark:hover:bg-gray-700/75 dark:active:border-gray-600">
                      <component :is="$outlineIcons.DocumentMagnifyingGlassIcon" class="flex-none inline-block ttp-icon-inside-box-03 opacity-100 group-hover:opacity-100" />
                      <span class="grow text-gray-500 ttp-text-xs font-normal">{{ $t("btn.btn_manage_history") }}</span>
                    </button>
                  </div>
                </div>
                <div class="space-y-1">
                  <div>
                    <router-link
                      :to="{
                        name: 'IncidentReportView',
                        params: { id: $route.params.id ? $route.params.id : incidentID },
                      }"
                      class="group ttp-text-xs font-medium flex items-center justify-between space-x-2 px-2.5 py-2 rounded-lg border border-transparent text-gray-700 hover:text-teal-800 hover:bg-teal-50 active:border-teal-100 dark:text-gray-200 dark:hover:text-white dark:hover:bg-gray-700/75 dark:active:border-gray-600"
                    >
                      <component :is="$outlineIcons.ClipboardDocumentListIcon" class="flex-none inline-block ttp-icon-inside-box-03 opacity-100 group-hover:opacity-100" />
                      <span class="grow text-gray-500 ttp-text-xs font-normal">{{ $t("btn.btn_view_report") }}</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="scrollContainer" class="flex flex-col gap-2 h-full border-b-[1px] p-4 overflow-auto">
        <LoadingFormComponent v-if="chatFormStore.loading" class="m-auto" />
        <template v-else v-for="item in chatFormStore.messages" :key="item.refID">
          <div v-if="item.sender == $enums.ENUM_CHAT_SENDER.TOURIST" class="ttp-tourist-chat flex flex-col gap-2">
            <span class="text-[#64748B] text-[12px]">{{ historySearchStore?.result?.tourist?.name }}</span>
            <div class="flex w-full">
              <template v-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.TEXT">
                <div class="flex bg-ttp-chat-left border rounded-tl-none rounded-tr-lg rounded-bl-lg rounded-br-lg w-full p-3">
                  <div class="relative pb-5">
                    <div class="text-black ttp-text-xs" v-html="item?.content ? item?.content : $hasNameAndValue(item?.message) ? (item?.message?.content.name ? item?.message?.content.name : $findPlaceholder(item)) : item?.message?.content ? item?.message?.content : $findPlaceholder(item)"></div>
                  </div>
                </div>
              </template>
              <template v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.SELECTED">
                <div class="bg-ttp-chat-left border rounded-tl-none rounded-tr-lg rounded-bl-lg rounded-br-lg w-full p-3">
                  <div class="relative pb-5">
                    <div class="text-black ttp-text-xs" v-html="item?.content ? item?.content : $hasNameAndValue(item?.message) ? (item?.message?.content.name ? item?.message?.content.name : $findPlaceholder(item)) : item?.message?.content ? item?.message?.content : $findPlaceholder(item)"></div>
                  </div>
                </div>
              </template>
              <template v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.IMAGES">
                <div v-if="item?.message?.content" class="w-full">
                  <div class="bg-ttp-chat-left border rounded-tl-none rounded-tr-lg rounded-bl-lg rounded-br-lg w-full p-3">
                    <div class="relative pb-5">
                      <div class="text-black ttp-text-xs">{{ $t("layout.select_picture") }}</div>
                    </div>
                  </div>
                  <div class="rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-none w-full p-3">
                    <div class="relative pb-5">
                      <div class="swipe-photo flex gap-2 w-full items-start justify-start">
                        <LoadingFormComponent v-if="$isArrayOfStringsOrObjects(item?.message?.content)" />
                        <a :href="_item?.url ? _item?.url : '#'" target="_blank" v-else v-for="(_item, index) in item?.message?.content" :key="index">
                          <img class="object-cover object-center w-14 h-14 sm:w-36 sm:h-36 max-w-full rounded-lg float-left mr-2" :src="_item?.url" alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="bg-ttp-chat-left border rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-none w-full p-3">
                  <div class="relative pb-5">
                    <div class="text-black ttp-text-xs" v-html="item?.content ? item?.content : $hasNameAndValue(item?.message) ? (item?.message?.content.name ? item?.message?.content.name : $findPlaceholder(item)) : item?.message?.content ? item?.message?.content : $findPlaceholder(item)"></div>
                  </div>
                </div>
              </template>
              <template v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.LOCATION">
                <a v-if="item?.message?.content?.latitude" :href="`https://maps.google.com/?q=${item?.message?.content?.latitude},${item?.message?.content?.longitude}`" target="_blank" class="bg-ttp-chat-left border rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-none w-full pb-2 overflow-hidden">
                  <div class="relative">
                    <div class="w-full mb-2">
                      <img :src="item?.message?.content?.url" class="object-cover object-center w-full h-36 max-w-full" />
                    </div>
                    <div class="px-3">
                      <div class="text-black ttp-text-xs" v-html="item?.message?.content?.name"></div>
                      <hr class="my-1 md:my-2" />
                      <div class="flex gap-1 items-center">
                        <div><component :is="$solidIcons.MapPinIcon" class="inline-block m-auto text-[#7B61FF] ttp-icon-inside-box-03 cursor-pointer" /></div>
                        <div class="text-[#7B61FF] ttp-text-xs pt-1">Location</div>
                        <div class="w-full text-right"><component :is="$solidIcons.ChevronRightIcon" class="flex-none inline-block ttp-icon-inside-box-03 text-[#7B61FF]" /></div>
                      </div>
                    </div>
                  </div>
                </a>
                <div v-else class="bg-ttp-chat-left border rounded-tl-none rounded-tr-lg rounded-bl-lg rounded-br-lg w-full p-3">
                  <div class="relative pb-5">
                    <div class="text-black ttp-text-xs">{{ $t("btn.btn_non") }}</div>
                  </div>
                </div>
              </template>
              <template v-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.MAKE_A_CALL">
                <div class="flex bg-ttp-chat-left border rounded-tl-none rounded-tr-lg rounded-bl-lg rounded-br-lg w-full p-3">
                  <div class="flex flex-col gap-3">
                    <div class="flex items-center gap-3">
                      <div class="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#2C3483]"><component :is="$solidIcons.PhoneIcon" class="flex-none inline-block ttp-icon-inside-box-03 mx-1 text-white" /></div>
                      <div class="text-black ttp-text-xs">{{ $t("page.ChatView.make_a_call") }}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.HANG_UP">
                <div class="flex bg-ttp-chat-left border rounded-tl-none rounded-tr-lg rounded-bl-lg rounded-br-lg w-full p-3">
                  <div class="flex flex-col gap-3">
                    <div class="flex items-center gap-3">
                      <div class="text-black ttp-text-xs">{{ $t("page.ChatView.hang_up") }}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.ANSWER_A_CALL">
                <div class="flex bg-ttp-chat-left border rounded-tl-none rounded-tr-lg rounded-bl-lg rounded-br-lg w-full p-3">
                  <div class="flex flex-col gap-3">
                    <div class="flex items-center gap-3">
                      <div class="text-black ttp-text-xs">{{ $t("page.ChatView.answer_a_call") }}</div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="w-0 lg:w-20"></div>
            </div>
            <span class="text-[#64748B] text-[12px]">{{ $dayjs(item?.datetime ? item?.datetime : item?.createdAt).format("HH:mm") }} {{ $t("page.ChatView.response_voice_call") }}</span>
          </div>

          <div v-else-if="item.sender === $enums.ENUM_CHAT_SENDER.SYSTEM" class="ttp-police-chat flex flex-col gap-2">
            <div class="flex w-full">
              <div class="w-12 lg:w-20"></div>
              <div class="bg-ttp-chat-right flex flex-col border rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-none w-full p-3 gap-1">
                <div class="text-white relative">
                  <template v-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.TEXT">
                    <div class="ttp-text-xs mb-2" v-html="$replaceString(item?.message?.content?.message, '%name%', $convertString(authStore?.user?.name))"></div>
                  </template>
                  <template v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.SELECT">
                    <div class="relative">
                      <div class="ttp-text-xs mb-2" v-html="item?.message?.content?.message"></div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="relative text-ttp-primary ttp-text-sm">
              <div class="text-[12px] text-[#64748B] text-right">{{ $dayjs(item?.datetime ? item?.datetime : item?.createdAt).format("HH:mm") }} {{ $t("page.ChatView.response_bot") }}</div>
            </div>
          </div>

          <div v-else-if="item.sender === $enums.ENUM_CHAT_SENDER.USER" class="ttp-police-chat flex flex-col gap-2">
            <div class="flex w-full items-end">
              <div class="w-12 lg:w-20"></div>
              <div class="bg-ttp-chat-right flex flex-col border rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-none w-full p-3 gap-1">
                <div class="text-white relative">
                  <template v-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.TEXT">
                    <div class="ttp-text-xs mb-2">
                      {{ item?.content ? item?.content : $hasNameAndValue(item?.message) ? (item?.message?.content.name ? item?.message?.content.name : $findPlaceholder(item)) : item?.message?.content ? item?.message?.content : $findPlaceholder(item) }}
                    </div>
                  </template>
                  <template v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.IMAGES">
                    <div v-if="item?.message?.content" class="w-full">
                      <div class="rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-none w-full p-3">
                        <div class="relative pb-5">
                          <div class="swipe-photo flex gap-2 w-full items-end justify-end">
                            <LoadingFormComponent v-if="$isArrayOfStringsOrObjects(item?.message?.content)" />
                            <a :href="_item?.url ? _item?.url : '#'" target="_blank" v-else v-for="(_item, index) in item?.message?.content" :key="index">
                              <img class="object-cover object-center w-14 h-14 sm:w-36 sm:h-36 max-w-full rounded-lg float-left mr-2" :src="_item?.url" alt="" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="bg-ttp-chat-left border rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-none w-full p-3">
                      <div class="relative pb-5">
                        <div class="text-black ttp-text-xs" v-html="item?.content ? item?.content : $hasNameAndValue(item?.message) ? (item?.message?.content.name ? item?.message?.content.name : $findPlaceholder(item)) : item?.message?.content ? item?.message?.content : $findPlaceholder(item)"></div>
                      </div>
                    </div>
                  </template>

                  <template v-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.MAKE_A_CALL">
                    <div class="flex items-center gap-3">
                      <div class="inline-flex h-14 w-14 items-center justify-center rounded-full bg-white"><component :is="$solidIcons.PhoneIcon" class="flex-none inline-block ttp-icon-inside-box-03 mx-1 text-ttp-primary" /></div>
                      <div class="ttp-text-xs mb-2">{{ $t("page.ChatView.make_a_call") }}</div>
                    </div>
                  </template>
                  <template v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.HANG_UP">
                    <div class="flex items-center gap-3">
                      <div class="ttp-text-xs mb-2">{{ $t("page.ChatView.hang_up") }}</div>
                    </div>
                  </template>
                  <template v-else-if="item?.message?.type == $enums.ENUM_CHAT_TYPE.ANSWER_A_CALL">
                    <div class="flex items-center gap-3">
                      <div class="ttp-text-xs mb-2">{{ $t("page.ChatView.answer_a_call") }}</div>
                    </div>
                  </template>
                </div>
              </div>
              <Menu v-if="[$enums.ENUM_CHAT_TYPE.TEXT, $enums.ENUM_CHAT_TYPE.IMAGES].includes(item?.message?.type)" as="div" class="inline-block relative">
                <MenuButton class="p-2">
                  <component :is="$outlineIcons.EllipsisVerticalIcon" class="inline-block ttp-icon-inside-box-03" />
                </MenuButton>
                <MenuItems class="absolute w-40 right-1 origin-top-right z-10 mt-2 w-4/4 shadow-md rounded-lg dark:shadow-gray-900 focus:outline-none">
                  <div class="bg-white ring-1 ring-black ring-opacity-5 rounded-lg divide-y divide-gray-100 dark:bg-gray-800 dark:divide-gray-700 dark:ring-gray-700">
                    <div class="space-y-1">
                      <MenuItem v-slot="{ active }">
                        <button
                          class="w-full group ttp-text-xs font-medium flex items-center justify-between space-x-2 px-2.5 py-2 rounded-lg border border-transparent"
                          :class="{
                            'text-teal-800 bg-teal-50 dark:text-white dark:bg-gray-700/75 dark:border-transparent': active,
                            'text-gray-700 hover:text-teal-800 hover:bg-teal-50 active:border-teal-100 dark:text-gray-200 dark:hover:text-white dark:hover:bg-gray-700/75 dark:active:border-gray-600': !active,
                          }"
                          @click="cancelMessage(item.refID)"
                        >
                          <component :is="$outlineIcons.TrashIcon" class="flex-none inline-block ttp-icon-inside-box-03 opacity-100 group-hover:opacity-100" />
                          <span class="grow text-gray-500 ttp-text-xs font-normal">
                            ยกเลิกข้อความ
                          </span>
                        </button>
                      </MenuItem>
                    </div>
                  </div>
                </MenuItems>
              </Menu>
            </div>
            <div class="relative text-ttp-primary ttp-text-sm">
              <div class="text-[12px] text-[#64748B] text-right">{{ $dayjs(item?.datetime ? item?.datetime : item?.createdAt).format("HH:mm") }} {{ $t("page.ChatView.response_police") }}</div>
            </div>
          </div>
        </template>
      </div>
      <form
        @submit.prevent="
          async (e: any) => {
            await chatFormStore.onSubmit(e);
            scrollBottom(100);
          }
        "
        class="flex gap-2 w-full h-[80px] p-4 items-center justify-center relative"
      >
        <div class="absolute -mt-[4px] right-[70px] z-[9999]">
          <label for="file-upload" class="icon-container relative">
            <component :is="$solidIcons.PaperClipIcon" class="inline-block m-auto text-ttp-primary ttp-icon-inside-box-03 cursor-pointer" />
            <input type="file" ref="fileInput" @change="changeFile" id="file-upload" class="hidden" accept="image/*" multiple />
          </label>
        </div>
        <div class="w-full"><component :classTagName="'col-start-1 col-end-7 md:col-start-3 md:col-end-7'" :is="defaultFormComponents.form.input.message.component" v-bind="defaultFormComponents.form.input.message.props" @updateValue="defaultFormComponents.form.input.message.onUpdateValue" /></div>
        <div class="">
          <button :disabled="chatFormStore.loading" class="disabled:cursor-not-allowed disabled:opacity-50 inline-flex ttp-icon-box-03 items-center justify-center rounded bg-[#212A83] text-gray-300 dark:bg-gray-700 dark:text-gray-500">
            <svg class="ttp-icon-inside-box-03" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.4354 2.58198C20.9352 2.0686 20.1949 1.87734 19.5046 2.07866L3.408 6.75952C2.6797 6.96186 2.16349 7.54269 2.02443 8.28055C1.88237 9.0315 2.37858 9.98479 3.02684 10.3834L8.0599 13.4768C8.57611 13.7939 9.24238 13.7144 9.66956 13.2835L15.4329 7.4843C15.723 7.18231 16.2032 7.18231 16.4934 7.4843C16.7835 7.77623 16.7835 8.24935 16.4934 8.55134L10.72 14.3516C10.2918 14.7814 10.2118 15.4508 10.5269 15.9702L13.6022 21.0538C13.9623 21.6577 14.5826 22 15.2628 22C15.3429 22 15.4329 22 15.513 21.9899C16.2933 21.8893 16.9135 21.3558 17.1436 20.6008L21.9156 4.52479C22.1257 3.84028 21.9356 3.09537 21.4354 2.58198Z" fill="white" />
            </svg>
          </button>
        </div>
      </form>
    </div>
    <div v-else class="flex flex-col w-full h-full border-l-[1px]">
      <div class="flex gap-2 w-full h-full p-4 bg-[#D9D9D9] items-center justify-center relative">
        <div id="page-footer" class="w-full z-10 bottom-0 flex flex-col items-center">
          <div class="text-[#4E4E4E] ttp-text-xl">ไม่พบรายการสนทนา</div>
          <div class="text-[#898A8D] text-center ttp-text-sm">กรุณาเลือกห้องสนทนาจัดการเหตุการณ์</div>
        </div>
      </div>
    </div>
  </div>

  <TransitionRoot appear :show="incidentFormStore.isHistory" as="template">
    <Dialog as="div" @close="incidentFormStore.closeHistoryModal" class="relative z-9999" :show="incidentFormStore.isHistory">
      <div class="fixed inset-0 bg-gray-900 bg-opacity-75 backdrop-blur-sm" />
      <div class="fixed inset-0 overflow-y-auto p-4 lg:p-8">
        <DialogPanel class="w-full max-w-xl mx-auto flex flex-col rounded-lg shadow-md bg-white overflow-hidden dark:text-gray-100 dark:bg-gray-800">
          <div class="relative p-4">
            <div class="flex">
              <div class="w-full text-gray-800 ttp-text-base font-medium leading-normal">
                <div class="inline-flex items-center justify-center px-3 py-2">{{ $t("page.IncidentNoticeView.history") }} ({{ $t("page.IncidentNoticeView.number_code") }} {{ $convertString(incidentFormStore?.result?.incidentNumber) }})</div>
              </div>
              <div class="text-right">
                <button @click="incidentFormStore.closeHistoryModal" type="button" class="inline-flex items-center justify-center space-x-2 rounded-lg border border-transparent px-3 py-2 ttp-text-xs font-semibold leading-5 text-gray-800 hover:text-gray-900 focus:ring focus:ring-gray-300 focus:ring-opacity-25 active:border-gray-200 active:shadow-none dark:border-transparent dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200 dark:focus:ring-gray-600 dark:focus:ring-opacity-40 dark:active:border-gray-700">
                  <component :is="$solidIcons.XMarkIcon" class="inline-block ttp-icon-inside-box-03" />
                </button>
              </div>
            </div>
            <div class="my-5">
              <div class="relative py-5 dark:text-gray-100">
                <div class="w-6 md:w-12 lg:ml-40 absolute top-0 left-0 bottom-0 flex flex-col justify-center" aria-hidden="true">
                  <div class="mx-auto w-1 h-2.5 grow-0 bg-gradient-to-b from-transparent to-teal-100 rounded-t dark:to-teal-900"></div>
                  <div class="mx-auto w-1 grow bg-ttp-new dark:bg-ttp-new"></div>
                  <div class="mx-auto w-1 h-2.5 grow-0 bg-gradient-to-t from-transparent to-teal-100 rounded-b dark:to-teal-900"></div>
                </div>
                <ul class="relative space-y-4 pl-10 md:pl-12 lg:ml-40">
                  <li v-for="(data, n) in incidentFormStore?.result?.progress" :key="n" class="relative">
                    <div class="w-14 md:w-12 absolute top-0 left-0 bottom-0 -translate-x-full flex justify-center mt-3">
                      <div v-if="n == 0" class="ttp-icon-inside-box-03 text-white bg-ttp-success rounded-full flex items-center justify-center dark:text-teal-900 dark:bg-teal-300 dark:ring-teal-900 dark:ring-offset-gray-900">
                        <component :is="$solidIcons.CheckIcon" class="inline-block h-4 w-4" />
                      </div>

                      <div v-else class="ttp-icon-inside-box-04 bg-ttp-new rounded-full dark:bg-teal-300 dark:ring-teal-900 dark:ring-offset-gray-900"></div>
                    </div>
                    <div class="bg-gray-100 hover:ring hover:ring-gray-100 hover:ring-offset-2 rounded-xl p-4 dark:bg-gray-800 dark:hover:ring-gray-700 dark:ring-offset-gray-900">
                      <div class="px-1 ttp-text-xs leading-[14px] mb-2">
                        <component :is="defaultFormComponents.form.badge.status.component" v-bind="defaultFormComponents.form.badge.status.props" :title="$formattedStatus($classStatus(data?.status))" :classEnumName="$classStatus(data?.status)" />
                      </div>
                      <div class="px-1 mt-2 ttp-text-xs leading-[14px]">
                        {{ masterDataStore.getStatusByCode($classStatus(data?.status), false) }}
                      </div>
                      <div class="px-1 mt-2 ttp-text-xs text-gray-500 leading-[14px]">
                        {{ $t("layout.result") }} :
                        {{ $convertString(data?.detail) }}
                      </div>
                      <div class="px-1 mt-2 ttp-text-xs text-gray-500 leading-[14px]">
                        {{ masterDataStore.getStatusDetailByCode($classStatus(data?.status)) }}
                        :
                        {{ $convertString(data?.assignee?.content[0]?.shortName) }}
                      </div>
                    </div>

                    <div class="px-4 py-2 lg:w-40 lg:absolute lg:top-0 lg:left-0 lg:bottom-0 lg:-translate-x-full lg:flex lg:flex-col lg:text-right lg:mt-4 lg:-ml-12 lg:p-0">
                      <div class="ttp-text-xs font-bold text-[#2c3483]">{{ $t("progress.processing_time") }}</div>
                      <div class="ttp-text-xs mb-2">{{ $dayjs(data?.createdAt).format("DD/MM/YYYY") }} {{ $dayjs(data?.createdAt).format("HH:mm") }}</div>
                      <div v-if="n + 1 != incidentFormStore?.result?.progress?.length" class="ttp-text-xs font-bold text-[#2c3483]">{{ $t("progress.period_time") }}</div>
                      <div v-if="n + 1 != incidentFormStore?.result?.progress?.length" class="ttp-text-xs">{{ $calculateTimeDifference(new Date(incidentFormStore?.result?.progress[n + 1]?.createdAt), new Date(data?.createdAt), masterDataStore.lang()) }}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
